module.exports = __webpack_public_path__ + "img/accepted.8cfee7b1.png";